export const categories = [
  { name: $localize`Maintenance`, value: 'maintenance' },
  { name: $localize`Supplies`, value: 'supplies' },
  { name: $localize`Safety`, value: 'safety' },
  { name: $localize`Housekeeping`, value: 'housekeeping' },
  { name: $localize`Facilities`, value: 'facilities' },
  { name: $localize`Guest`, value: 'guest' },
  { name: $localize`Utilities`, value: 'utilities' },
  { name: $localize`Equipment`, value: 'equipment' },
]
